import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { wsbaseURL } from 'config/config';
import { storage, KEYS } from 'Utils/storage';

/**
 * WebSocket link for GraphQL subscriptions.
 * Auth token is sent via connectionParams on every connection.
 *
 * Note: XMPP (SocketClient) is the primary real-time transport in practice.
 * This link is configured but subscription operations are rarely used.
 */
export const wsLink = new GraphQLWsLink(
    createClient({
        url: wsbaseURL + '/graphql',
        connectionParams: () => {
            const token = storage.get(KEYS.TOKEN);
            return {
                authToken: token ? `Bearer ${token}` : '',
            };
        },
    })
);
